// import './css/PendenciaFormularioAcompanhamento.css';

import toast from 'react-hot-toast';
import { useEffect, useState } from 'react';

import TituloSessao from '../componentes/TituloSessao';
import SelectStatus from '../componentes/SelectStatus';
import ModalRespPend from '../componentes/ModalRespPend';
import BarraBuscaComTodasUnidades from '../componentes/BarraBuscaComTodasUnidades';
import SelectBlocoItemFormulario from '../componentes/SelectBlocoItemFormulario';
import DataMes from '../componentes/DataMes';
import Paginador from '../componentes/Paginador';

import { formataDate } from '../util/datas'

import { servGetPendenciasFormularioAcompanhamento } from '../servicos/servicosEmRotasPrivadas/pendencia_relatorio_acompanhamento';
import smartToast from '../util/smart_toast';
import { servGetAllStatusTransitorios } from '../servicos/servicosEmRotasPrivadas/status';
import { toastErrorFromResponse } from '../util/utilitarios';

function ResponderPendencias() {

    console.log('###Iniciando Consulta a pendência de itens do Relatório de Acompanhamento###')

    const [pendenciasItemFormulario, setPendenciasItemFormulario] = useState([])
    const [statusOpcoes, setStatusOpcoes] = useState(null)
    const [page, setPage] = useState(null)
    const [showModalComPend, setShowModalComPend] = useState({
        status: false,
        pendenciaId: null
    });
    const [query, setQuery] = useState({
        blocoItemId: null,
        estabelecimentoId: null,
        mesCompetencia: null,
        statusId: null
    });

    const fecharModal = () => setShowModalComPend(false);

    useEffect(() => {
        if (page !== null) getPendenciasFormularioAcompanhamento()
    }, [page]);

    useEffect(() => {

        const getAllStatusTransitorios = async () => {
            try {
                const statusDaApi = await servGetAllStatusTransitorios()
                setStatusOpcoes(statusDaApi)
            } catch (error) {
                toastErrorFromResponse(error)
            }
        }

        getAllStatusTransitorios()

    }, []);

    const getPendenciasFormularioAcompanhamento = async () => {
        try {
            const pendenciasDaApi = await smartToast(
                servGetPendenciasFormularioAcompanhamento(query, page),
                {
                    loadingMessage: 'Buscando pendências...',
                    apenasLoading: true
                },
            );
            setPendenciasItemFormulario(pendenciasDaApi.data);
            if (pendenciasDaApi.data.pendencias.length < 1) toast('Não há pendências para os filtros selecionados')
        } catch (erro) {
            console.log(erro);
            toast.error(erro.message)
        }
    }

    const buscarPendencias = () => {
        if (page === 1) {
            console.log('Como a página está zerada, eu mesmo terei que chamar...');
            if (page !== null) getPendenciasFormularioAcompanhamento()
        }
        setPage(1)
    }

    const handlerChangeQuery = (campo, valor) => {
        setQuery(prev => ({
            ...prev,
            [campo]: valor
        }));
    };

    return (
        <div className='container-fluid d-flex flex-column gap-3'>
            <ModalRespPend
                show={showModalComPend.status}
                handleClose={fecharModal}
                pendenciaId={showModalComPend.pendenciaId}
                fetchItensAoFechar={getPendenciasFormularioAcompanhamento}
                statusOpcoes={statusOpcoes}
            />
            <TituloSessao titulo="Pendências de itens" barraDecorativa={false} />
            <div className='div-com-borda container d-flex flex-column gap-2 p-3'>
                <div className='d-flex flex-column flex-md-row gap-3'>
                    <div className='d-flex flex-column flex-md-row gap-2 align-items-center col-12 col-md-3'>
                        <label className='text-nowrap' htmlFor='filtro-mes-pendencia'>Mês Competência</label>
                        <DataMes id='filtro-mes-pendencia'
                            setData={(value) => handlerChangeQuery("mesCompetencia", value)}
                            getUltimoDia={false}
                        />
                    </div>
                    <div className='col-12 col-md-3'>
                        <SelectStatus setStatus={(value) => handlerChangeQuery("statusId", value)} />
                    </div>
                    <div className='col-12 col-md-5'>
                        <SelectBlocoItemFormulario setBlocoItem={(value) => handlerChangeQuery("blocoItemId", value)} />
                    </div>
                </div>
                <div className='w-100'>
                    <BarraBuscaComTodasUnidades
                        setEstabelecimento={(value) => handlerChangeQuery("estabelecimentoId", value ? value.id : null)}
                        estabelecimentosVigentes={false}
                        apenasQueEnviamRelatorio={false}
                    />
                </div>
            </div>
            <div className='container'>
                <button className="btn btn-primary" type="button" onClick={() => buscarPendencias()}>BUSCAR</button>
            </div>
            {pendenciasItemFormulario.pendencias &&
                <div className="table-responsive">
                    <table className='table text-center table-striped'>
                        <thead>
                            <tr>
                                <th scope="col" className='p-1' >Bloco Pergunta</th>
                                <th scope="col" className='p-1' >Pergunta</th>
                                <th scope="col" className='p-1' >Estabelecimento</th>
                                <th scope="col" className='p-1' >Mês Referência</th>
                                <th scope="col" className='p-1' >Observação</th>
                                <th scope="col" className='p-1' >Status</th>
                                <th scope="col" className='p-1' >Resposta</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pendenciasItemFormulario.pendencias.map((pendencia) => {
                                return (
                                    <tr key={pendencia.pendenciaId}>
                                        <td className='p-1'>{pendencia.blocoModeloItem}</td>
                                        <td className='p-1'>
                                            {pendencia.blocoModeloItemId}.{pendencia.codigoItem} - {pendencia.descricaoItem}
                                            {pendencia.notaItem && <i><small>{pendencia.notaItem}</small></i>}</td>
                                        <td className='p-1'>{pendencia.estabelecimento}</td>
                                        <td className='p-1'>{formataDate(pendencia.mesReferencia)}</td>
                                        <td className='p-1'>{pendencia.itemObs}</td>
                                        <td className='p-1'>{pendencia.statusItem}</td>
                                        <td className='p-1'><button className='btn btn-primary' onClick={() => setShowModalComPend({ status: true, pendenciaId: pendencia.pendenciaId })}>RESPONDER</button></td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    <Paginador
                        page={page}
                        setPage={setPage}
                        itemsPerPage={pendenciasItemFormulario.perPage}
                        totalItems={pendenciasItemFormulario.total}
                    />
                </div>
            }
        </div>
    );
}

export default ResponderPendencias
